import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { SessionHelper } from "../../../core/helper/sessionHelper";
import { A3LCompany } from "../../../core/models/a3Lcompany.model";
import { A3LCompanyService } from "../../../core/services/a3LCompany.service";
import { ISelector } from "../interfaz/ISelector";
import { SelectorBase } from "../selectorBase";
import { createCustomInputControlValueAccessor } from "../../base/Input.component";

@Component({
  selector: 'app-company-selector',
  templateUrl: './company-selector.component.html',
  styleUrls: ['./company-selector.component.scss'],
  providers: [A3LCompanyService, createCustomInputControlValueAccessor(CompanySelectorComponent)]
})
export class CompanySelectorComponent extends SelectorBase<number, A3LCompany> implements OnDestroy, OnInit, ISelector<A3LCompany> {

  constructor(private companyService: A3LCompanyService,
    private sessionHelper: SessionHelper,
    ref: ChangeDetectorRef) {
    super(ref, "company");
    this.selectedValueDescription = "";
  }

  selectedValueDescription: string;

  @Output() selectedValueChange = new EventEmitter<A3LCompany>();
  @Output() onEntitiesLoaded = new EventEmitter<boolean>();

  @Input() placeHolder: string = "";
  @Input() dataSize: number = 7;
  @Input() required: boolean;
  @Input() emptyOption: false;
  @Input() disabled: boolean;
  @Input() multiple: boolean;
  @Input() tabIndex: number;
  @Input() onlyConfigured: boolean = false;
  @Input() gestionEmpleados: boolean = false;

  loading: boolean = false;

  getEntities() {

    this.disableDetectChanges();

    this.entities = undefined;

    this.getFromLocalStorage();

    this.companyService.getAllForSelect(this.onlyConfigured, this.gestionEmpleados).subscribe((response: A3LCompany[]) => {
      if (response) {
        this.entities = response;
        this.enableDetectChanges();
        this.safeOnLocalStorage();
        this.onEntitiesLoaded.emit(true);
      }

    }, error => {
      console.error(error)
      this.onEntitiesLoaded.emit(false);
      this.enableDetectChanges();
    });
  }

  getKeyLocalstorage(): string {
    return `companies${this.sessionHelper.User.IdCliente}OnlyConfigured=${String(this.onlyConfigured)}`;
  }

  ngOnInit() {
    this.getEntities();
  }

  onSelectedValueChange(event) {
    // console.log(event);
    this.value = event;
    const entity = this.entities?.find(x => x.companyCode === this.value);
    // console.log("entity", entity);
    this.selectedValueDescription = entity?.companyName ?? "";
    this.selectedValueChange.emit(entity);
  }

  ngOnDestroy(): void {
    this.selectedValueChange = undefined;
  }

}
